import {combineReducers} from '@reduxjs/toolkit';

import {ssoAccountsStateSlice} from './sso-accounts-state.slice';
import {ssoAccountsSlice} from './sso-accounts.slice';

export const ssoAccountsReducer = combineReducers({
    result: ssoAccountsSlice.reducer,
    state: ssoAccountsStateSlice.reducer,
});
